import { baseApi } from "./base.api";
import { API_CONFIG } from "../config/api.config";
import { refreshCoordinator } from "../offline/auth/refresh-coordinator.js";

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export const authService = {
  login(username, password) {
    return baseApi.post(API_CONFIG.ENDPOINTS.AUTH.LOGIN, {
      username,
      password,
    });
  },
  logout() {
    return baseApi.post(API_CONFIG.ENDPOINTS.AUTH.LOGOUT);
  },
  /**
   * Refresh access token using the shared RefreshCoordinator.
   * This ensures ALL refresh paths (user-context, base.api.js 401 handler,
   * sync engine) go through the same coordinator, preventing race conditions
   * from concurrent token rotation.
   */
  async refresh() {
    const accessToken = await refreshCoordinator.executeRefresh(
      `${BASE_URL}${API_CONFIG.ENDPOINTS.AUTH.REFRESH}`
    );
    return { accessToken, queued: false };
  },
  telegramLogin(token) {
    return baseApi.post(
      `${API_CONFIG.ENDPOINTS.AUTH.TELEGRAM_LOGIN}?token=${token}`,
    );
  },
  getUserLanguage() {
    return baseApi.get("/auth/language");
  },
  updateUserLanguage(language) {
    return baseApi.put("/auth/language", { language });
  },
};
